import apiFunc from '@/api'
import axios from '@/utils/axios'

const api = apiFunc(axios)

export default {
  namespaced: true,
  state: {
    refresh_token: '',
    access_token: '',
    loggedInUser: {},
    isAuthenticated: false
  },
  getters: {
    loggedInUser: state => state.loggedInUser,
    isAuthenticated: state => state.isAuthenticated,
    accessToken: state => state.access_token,
    refreshToken: state => state.refresh_token
  },
  mutations: {
    setRefreshToken: function (state, refreshToken) {
      state.refresh_token = refreshToken
    },
    setAccessToken: function (state, accessToken) {
      state.access_token = accessToken
    },
    setLoggedInUser: function (state, user) {
      state.loggedInUser = user
      state.isAuthenticated = true
    },
    clearUserData: function (state) {
      state.refresh_token = ''
      state.access_token = ''
      state.loggedInUser = {}
      state.isAuthenticated = false
    }
  },
  actions: {
    async logIn ({ commit, dispatch }, payload) {
      const response = await api.auth.login(payload)

      if (response.status === 200) {
        commit('setRefreshToken', response.data.refreshToken)
        commit('setAccessToken', response.data.accessToken)
        await dispatch('fetchUser')
        // router.push('/')

        window.location.href = '/'
      }
    },
    logout ({ commit }) {
      commit('clearUserData')
      window.location.href = '/login'
    },
    async refreshToken ({ state, commit }) {
      try {
        const response = await api.auth.refreshToken(state.refresh_token)

        console.log(response)

        if (response.status === 200) {
          commit('setAccessToken', response.data.accessToken)
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async fetchUser ({ commit }) {
      try {
        const response = await api.auth.me()
        const data = response?.data ?? {}

        const body = {
          name: data.name,
          surname: data.surname,
          notification: data.notif,
          photo: data.photo?.url,
          role: data.role,
          post: data.roleLabel
        }

        if (response.status === 200) {
          commit('setLoggedInUser', body)
        }
      } catch (e) {
        console.log(e.response)
      }
    }
  }
}
